























import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
  QueryCommunityPagedList,
  DeleteCommunity
} from "@/api/pdCommunity/index";
import CommunityDetail from "./detail.vue";
/**
 * 社区管理
 */
@Component({
  components: {
    CommunityDetail
  }
})
export default class Community extends AbpBase {
  data: any[] = [];
  loading: boolean = false;
  tableTotalSize: number = 0;
  showDetail: boolean = false;
  currentCommunity: any = {};

  queryCondition: any = {
    QueryString: "",
    SkipCount: 1,
    MaxResultCount: 10,
    SortKey: "id",
    SortOrder: "asc",
  };

  columns = [
    {
      key: "code",
      width: 150,
      title: "社区编码"
    },
    {
      key: "name",
      title: "社区名称"
    },
    {
      key: "parentName",
      title: "上级社区"
    },
    {
      key: "",
      width: 200,
      title: "操作",
      render: (h: any, p: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: { type: "primary", size: "small" },
              style: { marginRight: "5px" },
              on: {
                click: () => {
                  this.handleUpdateCommunity(p.row);
                }
              }
            },
            "编辑"
          ),
          h(
            "Button",
            {
              props: { type: "error", size: "small" },
              style: { marginRight: "5px" },
              on: {
                click: (event: any) => {
                  this.handleDeleteCommunity(p.row);
                }
              }
            },
            "删除"
          )
        ]);
      }
    }
  ];

  handleInsertCommunity() {
    this.currentCommunity = { id: 0 };
    this.showDetail = true;
  }

  handleUpdateCommunity(row: any) {
    this.currentCommunity = row;
    this.showDetail = true;
  }

  handleDeleteCommunity(row: any) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: "确定要删除此社区吗？",
      onOk: async () => {
        await DeleteCommunity(row.id);
        this.getData();
      }
    });
  }

  async getData() {
    this.loading = true;
    let res = await QueryCommunityPagedList(this.queryCondition);
    this.data = res.items;
    this.tableTotalSize = res.totalCount;
    this.loading = false;
  }

  handlePageChange(val: any) {
    this.queryCondition.SkipCount = val;
    this.getData();
  }

  handleOk() {
    this.loading = true;
    this.$refs.CommunityDetail.submit().then(res => {
      if (res) {
        this.showDetail = false;
        this.getData();
      }
      this.loading = false;
    });
  }

  created() {
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/community/index.vue